import { render, staticRenderFns } from "./ModuleList.vue?vue&type=template&id=dd6f7322&scoped=true"
import script from "./ModuleList.vue?vue&type=script&lang=js"
export * from "./ModuleList.vue?vue&type=script&lang=js"
import style0 from "./ModuleList.vue?vue&type=style&index=0&id=dd6f7322&prod&lang=less&scoped=true"
import style1 from "./ModuleList.vue?vue&type=style&index=1&id=dd6f7322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f7322",
  null
  
)

export default component.exports